<header>
  <div class="header-r1">
    <a href="https://www.sony.com/en" target="_blank" title="Sony"
      ><img class="logo-1" [src]="logoPath1" [alt]="'Sony Logo'"
    /></a>
  </div>
  <div class="header-r2">
    <a routerLink="/" title="Home" class="logo-2"
      ><img [src]="logoPath2" [alt]="'Sony Pictures Logo'"
    /></a>
    <app-global-search
      *ngIf="this.currentUser?.isAuthenticated && this.currentUser?.isLegalAccepted"
    ></app-global-search>
    <div
      *ngIf="
        this.currentUser?.isAuthenticated &&
        this.currentUser?.isLegalAccepted &&
        territoryDropdownInd &&
        !this.selectedUserGroupTerritory?.includes('undefined')
      "
    >
      <div class="header-btns">
        <button class="territory-dropdown border-0" [matMenuTriggerFor]="territory">
          {{ selectedUserGroupTerritory }}
          <mat-icon class="mat-icon territory-dropdown">arrow_drop_down</mat-icon>
        </button>
        <mat-menu
          class="header__menu--items territory-dropdown-prop"
          #territory="matMenu"
          xPosition="before"
        >
          <label class="territory-dropdown-header">{{ 'group-label' | translate }}</label>
          <br />
          <span
            class="territory-dropdown-label"
            *ngIf="checkArray(territoryExhibitor) && checkExhibitorLabel(territoryExhibitor)"
            >Exhibitor Relations</span
          >
          <a
            class="header__menu--items territory-dropdown-prop a"
            [routerLink]="getRouteUrlTerritory(territory)"
            (contextmenu)="onRightClick(territory)"
            *ngFor="let territory of territoryExhibitor"
            (click)="switchTerritory(territory, 'E')"
            [class.hidden]="
              territory.territoryName === selectedTerritory &&
              currentUser.selectedTerritory.groupTypeCode === 'E'
            "
          >
            <span>{{ territory.territoryName }} </span>
          </a>
          <span
            *ngIf="checkArray(territoryPublicity) && checkPublicityLabel(territoryPublicity)"
            class="territory-dropdown-label"
            >Publicity</span
          >
          <a
            class="header__menu--items territory-dropdown-prop a"
            [routerLink]="getRouteUrlTerritory(territory)"
            (contextmenu)="onRightClick(territory)"
            *ngFor="let territory of territoryPublicity"
            (click)="switchTerritory(territory, 'P')"
            [class.hidden]="
              territory.territoryName === selectedTerritory &&
              currentUser.selectedTerritory.groupTypeCode === 'P'
            "
          >
            <span>{{ territory.territoryName }} </span>
          </a>
          <span
            *ngIf="checkArray(territoryVr) && checkVrLabel(territoryVr)"
            class="territory-dropdown-label"
            >Virtual Reality</span
          >
          <a
            class="header__menu--items territory-dropdown-prop a"
            [routerLink]="getRouteUrlTerritory(territory)"
            (contextmenu)="onRightClick(territory)"
            *ngFor="let territory of territoryVr"
            (click)="switchTerritory(territory, 'VR')"
            [class.hidden]="
              territory.territoryName === selectedTerritory &&
              currentUser.selectedTerritory.groupTypeCode === 'VR'
            "
          >
            <span>{{ territory.territoryName }} </span>
          </a>
        </mat-menu>
      </div>
    </div>

    <div
      class="header-btns"
      *ngIf="
        (this.currentUser?.isAuthenticated && this.currentUser?.isLegalAccepted && userPrivileges &&
        (userPrivileges.includes('Order In-Theatre Trailer') ||  userPrivileges.includes('Order POS'))) ||
        (this.currentUser?.isAuthenticated && this.currentUser?.isLegalAccepted && isReleaseScheduleAvailable)">
      <button *ngIf="isReleaseScheduleAvailable" mat-button class="order-in" (click)="openReleaseSchedule()" >
        <mat-icon>calendar_today</mat-icon>{{ 'release-schedule-header' | translate }}
      </button>
      <button *ngIf="userPrivileges.includes('Order In-Theatre Trailer')" mat-button class="order-in" 
      (click)="onTheaterTrailerClick()">
        <mat-icon>moviecreation</mat-icon>{{ 'order-in-theater-trailer-label' | translate }}
      </button>
      <button *ngIf="userPrivileges.includes('Order POS')" mat-button class="order-pos" (click)="onPOSClick()" >
        <mat-icon>moviecreation</mat-icon>
        {{ 'order-pos-label' | translate }}
      </button>
    </div>

    <button
      class="header__menu--button position-relative" mat-icon-button id="digital-cart" color="accent" (click)="toggleDigitalCart($event)"
      *ngIf="this.currentUser?.isAuthenticated && this.currentUser?.isLegalAccepted" >
      <mat-icon matBadgeOverlap="true" [matBadge]="itemCounts" [matBadgeHidden]="itemCounts <= 0" > shopping_cart </mat-icon>
      <!-- <p *ngIf="itemCounts" class="badge rounded-pill bg-success top-0 start-70 translate-middle">
        {{ itemCounts }}
      </p> -->
    </button>
    <dx-popover
      target="#digital-cart" position="bottom" [visible]="showCartPopover" [wrapperAttr]="{ id: 'digital-cart-popover' }">
      <div *dxTemplate="let data = model; of: 'content'">
        <dx-scroll-view showScrollbar="onScroll">
          <div class="header-menu__cart-title mb-3">
            {{ 'digital-cart-label' | translate }}
            <button
              *ngIf="itemList.length > 0; else noData"
              type="button"
              (click)="toggleDigitalCart($event)"
              [routerLink]="['/user/cart-checkout']"
              mat-raised-button
            >
              {{ 'checkout-label' | translate }}
            </button>
          </div>
          <div class="cart-selector">
            <div
              class="d-flex justify-content-start w-100 position-relative align-items-center button-cart-item remove-cart-button"
              *ngFor="let item of itemList"
            >
              <ngx-spinner
                class="asset-mapping-item-spinner"
                bdColor="rgba(0, 0, 0, 0.9)"
                size="medium"
                color="#fff"
                type="line-scale-pulse-out"
                [name]="item.runnerAssetReleaseId.toString()"
                [fullScreen]="false"
              >
              </ngx-spinner>
              <div class="img-cnt">
                <img [src]="item.thumbnailUrl" class="cart-selector__thumbnail" alt />
              </div>
              <div class="cart-selector__file-name">{{ item.fileName }}</div>
              <button
                data-bs-toggle="tooltip"
                data-bs-placement="top"
                title="{{ 'digital-cart-remove-asset-tooltip' | translate }}"
                class="ms-auto btn btn-dark btn-lg"
                (click)="onClickRemoveFromCart(item.runnerAssetReleaseId)"
              >
                <mat-icon>remove_circle_outline</mat-icon>
              </button>
            </div>
          </div>

          <ng-template #noData>
            <p class="instruction-text">{{ 'no-items-added-in-digital-cart-text' | translate }}</p>
          </ng-template>
        </dx-scroll-view>
      </div>
    </dx-popover>
    <button class="header__menu--button" mat-icon-button [matMenuTriggerFor]="languageSelector">
      <mat-icon>language</mat-icon>
    </button>
    <mat-menu class="header__menu--items language-selector" #languageSelector="matMenu">
      <h3 class="items-heading">{{ 'language-label' | translate }}<br /></h3>
      <button
        *ngFor="let lang of appLanguages; let i = index"
        mat-menu-item
        [value]="lang.localeCode"
        (click)="changeLanguage(lang.localeCode)"
        [disabled]="i === 0"
      >
        <span>
          <img
            class="language-icon img-fluid"
            src="/assets/img/flags/{{ lang.localeCode }}.svg"
            width="25"
            height="18"
            alt="English"
            title="lang.language"
          />
        </span>
        <span class="language-text">
          {{ lang.language }}
        </span>
      </button>
    </mat-menu>
    <ngx-skeleton-loader
      *ngIf="menuLoading"
      [count]="1"
      [animation]="'progress-dark'"
      [theme]="{
        height: '3rem',
        width: '4rem',
        'background-color': '#101010',
        border: '1px solid #101010',
        'animation-duration': '2s',
        'margin-bottom': '0',
        'margin-left': '1rem',
        'margin-top': '1rem'
      }"
    >
    </ngx-skeleton-loader>
    <button
      class="header__menu--button"
      mat-icon-button
      [matMenuTriggerFor]="menu"
      *ngIf="this.currentUser?.isAuthenticated && this.currentUser?.isLegalAccepted && !menuLoading"
    >
      <mat-icon>menu</mat-icon>
    </button>
    <mat-menu class="header__menu--items main-menu" #menu="matMenu">
      <div class="header-menu__title mb-3">{{ 'main-menu-label' | translate }}</div>
      <span *ngFor="let menuitem of menuItems">
        <a
          *ngIf="userPrivileges && !userPrivileges.includes(menuitem.name) && !menuitem.link && menuitem.id !== 'looker_studio'"
          [routerLink]="getRouteUrl(menuitem)"
          (click)="getMenuItem(menuitem)"
          mat-menu-item
        >
          <mat-icon color="accent">{{ menuitem.icon }}</mat-icon>
          <span *ngIf="menuitem.name === 'Home'">{{ 'home-label' | translate }}</span>
          <span *ngIf="menuitem.name === 'Manage Homepage'">{{
            'manage-homepage-label' | translate
          }}</span>
          <span *ngIf="menuitem.name === 'Manage Titles'">{{
            'manage-title-label' | translate
          }}</span>
          <span *ngIf="menuitem.name === 'Manage Theaters'">{{
            'manage-theaters-label' | translate
          }}</span>
          <span *ngIf="menuitem.name === 'Manage Users'">{{
            'manage-users-label' | translate
          }}</span>
          <span *ngIf="menuitem.name === 'Manage Campaigns'">{{
            'manage-campaigns-label' | translate
          }}</span>
          <span *ngIf="menuitem.name === 'Manage Restricted Assets Access'">{{
            'manage-restricted-assets-access-label' | translate
          }}</span>
          <span *ngIf="menuitem.name === 'Asset Category and Mapping'">{{
            'asset-category-mapping-label' | translate
          }}</span>
          <span *ngIf="menuitem.name === 'Screening'">{{ 'screening-label' | translate }}</span>
          <span *ngIf="menuitem.name === 'Group Sales Request'">{{
            'group-sales-request-label' | translate
          }}</span>
          <span *ngIf="menuitem.name === 'Group Sales'">{{ 'group-sales-label' | translate }}</span>
          <span *ngIf="menuitem.name === 'Data Insights Dashboard'">Analytics Dashboard</span>
          <span *ngIf="menuitem.name === 'My Account'">{{ 'my-account-label' | translate }}</span>
          <span *ngIf="menuitem.name === 'User Guides'">{{ 'user-guides-label' | translate }}</span>
        </a>
        <a
          *ngIf="userPrivileges && userPrivileges.includes(menuitem.name) && menuitem.link && menuitem.id !== 'looker_studio'"
          [href]="getRouteUrl(menuitem)"
          target="_blank"
          (click)="getMenuItem(menuitem)"
          mat-menu-item
        >
          <mat-icon color="accent">{{ menuitem.icon }}</mat-icon>
          <span *ngIf="menuitem.name === 'Screening'">{{ 'screening-label' | translate }}</span>
          <span *ngIf="menuitem.name === 'Group Sales Request'">{{
            'group-sales-request-label' | translate
          }}</span>
          <span *ngIf="menuitem.name === 'Group Sales'">{{ 'group-sales-label' | translate }}</span>
          <span *ngIf="menuitem.name === 'Data Insights Dashboard'">Analytics Dashboard</span>
          <span *ngIf="menuitem.name === 'My Account'">{{ 'my-account-label' | translate }}</span>
          <span *ngIf="menuitem.name === 'User Guides'">{{ 'user-guides-label' | translate }}</span>
        </a>
      </span>
      <a mat-menu-item (click)="this.authService.logout()">
        <mat-icon color="accent">power_settings_new</mat-icon>
        <span>{{ 'log-out-label' | translate }}</span>
      </a>
    </mat-menu>
  </div>
</header>